<template>
    <div class="w-full flex-1">
        <div class="w-full min-h-[calc(100dvh-96px)] md:min-h-0 flex flex-col items-center justify-center text-center gap-6 py-6 md:py-10">
            <div class="w-20 h-20 rounded-full bg-emerald-500 flex items-center justify-center">
                <Icon icon="check" :width="64" :height="64" class="text-white" />
            </div>
            <div class="flex flex-col items-center gap-3">
                <h1 class="self-stretch text-center text-[24px] leading-8 md:text-[30px] md:leading-9 font-semibold text-slate-800">
                    You're all set!
                </h1>
                <p class="self-stretch text-center text-slate-500 text-base leading-6 max-w-[420px] md:max-w-[420px]">
                    Thanks for sharing. We're now ready to tailor recommendations just for you.
                </p>
            </div>

            <QuizActionBar
                primaryLabel="Get started"
                desktop-padding-top="pt-4"
                :disabled="saving"
                @primary="goToApp"
            />
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import QuizActionBar from './QuizActionBar.vue';
import { useQuizWizard } from '@/composables/useQuizWizard';

const { saving, goToApp } = useQuizWizard();
</script>
